import React from 'react';

import { Container, Content } from './styles';

interface ComponentPARAMS {
  places: any;
}

const EndEditMap: React.FC<ComponentPARAMS> = ({ places }) => {
  return (
    <Container>
      <Content>
        <div className="div-data">
          {/* RUA, NÚMERO */}
          <h2>
            {places![0].address_components[0]?.types[0] === 'route'
              ? places![0].address_components[0]?.short_name
              : places![0].address_components[1]?.short_name}
            {places![0].address_components[0]?.types[0] === 'street_number' &&
              `, ${places![0].address_components[0]?.short_name}`}
          </h2>
          {/* BAIRRO */}
          <h2>
            {places![0].address_components[1]?.types[0] ===
            'sublocality_level_1'
              ? places![0].address_components[1]?.short_name
              : places![0].address_components[2]?.short_name}
          </h2>
          {/* COMPLEMENTO */}
          <h2 style={{ color: '#546E7A' }}>
            {places![0].address_components[7]?.types[0] === 'comp' &&
              places![0].address_components[7]?.short_name}
          </h2>
          {/* CEP */}
          <h2>
            {places![0].address_components[5]?.types[0] === 'postal_code'
              ? `CEP - ${places![0].address_components[5]?.short_name}`
              : `CEP - ${places![0].address_components[6]?.short_name}`}
          </h2>
          {/* CIDADE, ESTADO */}
          <h2>
            {places![0].address_components[2]?.types[0] ===
            'administrative_area_level_2'
              ? places![0].address_components[2]?.short_name
              : places![0].address_components[3]?.short_name}

            {places![0].address_components[3]?.types[0] ===
            'administrative_area_level_1'
              ? `, ${places![0].address_components[3]?.short_name}`
              : `, ${places![0].address_components[4]?.short_name}`}
          </h2>
        </div>

        {/* <button
          type="button"
          className="div-editar"
          onClick={() => setModalPerfilNumeroVisible(true)}
        >
          Editar Número
        </button> */}
      </Content>
    </Container>
  );
};

export default EndEditMap;
